import React from 'react';
import { FlexLayout, LayoutJustification } from '~/graphql/types';
import JustificationContainer, {
  Justification,
} from '~/components/atom/JustificationContainer';
import styled, { css } from 'styled-components';
import { BLUR_STYLES } from '../../Data/styles';

export type Props = Omit<FlexLayout, '__typename'> & {
  dataTestId?: string;
  blurred?: boolean | null;
};

const Flex: React.FCC<Props> = ({
  children,
  css,
  padding,
  margin,
  justification,
  align,
  gap,
  direction,
  blurred,
}) => (
  <Container
    padding={padding ? padding : ['base']}
    margin={margin ? margin : undefined}
    justification={convertToFrontendType(justification)}
    align={convertToFrontendType(align)}
    gap={gap ?? undefined}
    direction={direction ?? undefined}
    wrap="wrap"
    css={css}
    $blurred={blurred || false}
  >
    {children}
  </Container>
);

const convertToFrontendType = (
  justification?: LayoutJustification | null,
): Justification => {
  switch (justification) {
    case LayoutJustification.Start:
      return 'start';
    case LayoutJustification.End:
      return 'end';
    case LayoutJustification.Center:
      return 'center';
    case LayoutJustification.SpaceBetween:
      return 'space-between';
    case LayoutJustification.SpaceAround:
      return 'space-around';
    case LayoutJustification.Stretch:
      return 'stretch';

    default:
      return 'start';
  }
};

const Container = styled(JustificationContainer)<{ $blurred: boolean }>(
  ({ $blurred }) => css`
    ${$blurred && BLUR_STYLES};
  `,
);

export default Flex;
